import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import GoogleMapsApi from "../Maps/GMapsApi";
import { stylers } from "../Maps/stylers";
import markerTmpl from "../Maps/marker.tmpl";
import { Configuration } from "../Shared/Configuration";
var _googleMapsLink = " https://maps.google.com/?q=";
export var MapBuilder = /*#__PURE__*/function () {
  function MapBuilder() {
    _classCallCheck(this, MapBuilder);
  }

  _createClass(MapBuilder, null, [{
    key: "DrawMap",
    value: function DrawMap(element, addressData) {
      var _this = this;

      var config = new Configuration();
      config.GetConfigurationSetting("GoogleMapsAPIKey").then(function (gApiKey) {
        var gmapApi = new GoogleMapsApi(gApiKey); // Call map renderer

        gmapApi.load().then(function () {
          _this._renderMap(element, addressData);
        });
      });
    }
  }, {
    key: "GetGoogleMapsLink",
    value: function GetGoogleMapsLink(data) {
      var mapsLink = "";

      if (!!data && data.addressId > 0 && !!data.addressLine1) {
        var encodedParameters = encodeURI("".concat(data.addressLine1, "+").concat(data.city, "+").concat(data.state, "+").concat(data.postalCode));

        var _mapsLink = "".concat(_googleMapsLink).concat(encodedParameters);

        return _mapsLink;
      }

      return mapsLink;
    }
    /**
     * Render Map
     * @param {map obj} mapEl - Google Map
     * @param {obj} data - map data
     */

  }, {
    key: "_renderMap",
    value: function _renderMap(mapEl, data) {
      var options = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: stylers.styles,
        zoom: data.zoom,
        center: {
          lat: data.lat,
          lng: data.lng
        }
      };
      var map = new google.maps.Map(mapEl, options);

      this._renderMarker(map, data);
    }
    /**
     * Render Marker
     * Renders custom map marker and infowindow
     * @param {map element} mapEl
     * @param {object} data
     */

  }, {
    key: "_renderMarker",
    value: function _renderMarker(map, data) {
      var icon = {
        url: stylers.icons.red,
        scaledSize: new google.maps.Size(80, 80)
      };
      var tmpl = markerTmpl(data);
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(data.lat, data.lng),
        map: map,
        //icon: icon,
        title: data.title,
        content: tmpl,
        animation: google.maps.Animation.DROP
      });
      var infowindow = new google.maps.InfoWindow();

      this._handleMarkerClick(map, marker, infowindow);
    }
    /**
     * Handle Marker Click
     *
     * @param {map obj} mapEl
     * @param {marker} marker
     * @param {infowindow} infoWindow
     */

  }, {
    key: "_handleMarkerClick",
    value: function _handleMarkerClick(map, marker, infowindow) {
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.setContent(marker.content);
        infowindow.open(map, marker);
      });
      google.maps.event.addListener(map, 'click', function (event) {
        if (infowindow) {
          infowindow.close(map, infowindow);
        }
      });
    } //TODO: remove old code:

  }, {
    key: "xCreateMap",
    value: function xCreateMap(address, mapElement) {
      var geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(-34.397, 150.644);
      var myOptions = {
        zoom: 8,
        center: latlng,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        navigationControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapElement, myOptions);

      if (geocoder) {
        geocoder.geocode({
          'address': address
        }, function (results, status) {
          //let locationResult = results[0];
          if (status === google.maps.GeocoderStatus.OK) {
            if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {
              map.setCenter(results[0].geometry.location);
              var infowindow = new google.maps.InfoWindow({
                content: '<b>' + address + '</b>',
                size: new google.maps.Size(150, 50)
              });
              var marker = new google.maps.Marker({
                position: results[0].geometry.location,
                map: map,
                title: address
              });
              google.maps.event.addListener(marker, 'click', function () {
                infowindow.open(map, marker);
              }); //successful
            } else {//unsuccessful
              }
          } else {//unsuccessful
            }
        });
      }
    }
  }]);

  return MapBuilder;
}();